export default "__VITE_ASSET__CxX$h3bg__"